import {
  Directive, HostBinding, Input,
} from '@angular/core';


@Directive({
  selector: '[bsFormControlLabel]',
  exportAs: 'bs-form-control-label'
})
export class FormControlLabelDirective {
  @HostBinding('class.form-control-label') formClass: boolean = true;

  @HostBinding('class.version-2')
  @Input() isVersion2: boolean = false;

}
